import React, { useState } from "react";
import "./Jobs.css";
import Header from "./Header";

function Jobs() {
  const [selectedJob, setSelectedJob] = useState(null);
  const [showApplicationForm, setShowApplicationForm] = useState(false);

  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 2,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 3,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 4,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 5,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 6,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 7,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 8,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 9,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
    {
      id: 10,
      title: "Retail sales and store support",
      company: "Pyate",
      location: "Brahmavara",
      type: "On-site",
      benefits: "Medical, 401(k)",
      description:
        "Are you a driven leader with a passion for fashion, customer service, and building a team that inspires? fab’rik is seeking a Store Manager to lead one of our dynamic locations...",
    },
  ]);

  const handleJobClick = (job) => {
    setSelectedJob(job);
  };

  const handleJobClose = (jobId) => {
    setJobs(jobs.filter((job) => job.id !== jobId));
    if (selectedJob?.id === jobId) {
      setSelectedJob(null);
    }
  };

  const [applicationForm, setApplicationForm] = useState({
    name: "",
    email: "",
    address: "",
    experience: "",
  });

  const handleApplicationInputChange = (e) => {
    const { name, value } = e.target;
    setApplicationForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const handleConnect = (id) => {
    console.log('Job ID to save:', id);  // Log the job ID that is being sent
  
    fetch("https://pyate-backend-production-db97.up.railway.app/jobs/save_api", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ job_id: id }),  // Correct payload format
    })
      .then((response) => {
        console.log('Response status:', response.status);  // Check the status code
        return response.json();
      })
      .then((data) => {
        console.log('Save response:', data);  // Log the server response
        alert(data.message);  // Alert success message
      })
      .catch((error) => {
        console.error('Error:', error);  // Log any errors that occur
        alert('Failed to save job');
      });
  };  
  
  const [alertOn, setAlertOn] = useState(false);

  // Toggle the alert status
  const toggleAlert = () => {
    setAlertOn(!alertOn);
  };

  const submitApplication = () => {
    const applicationData = {
      name: applicationForm.name,
      email: applicationForm.email,
      address: applicationForm.address,
      experience: applicationForm.experience,
    };
  
    fetch('https://pyate-backend-production-db97.up.railway.app/jobs/submit_api', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(applicationData),
    })
      .then((response) => {
        console.log('Response:', response);  // Log the response object
        return response.json();
      })
      .then((data) => {
        console.log('Data:', data);  // Log the data you get back
        alert(data.message);
        setShowApplicationForm(false);
        setApplicationForm({
          name: '',
          email: '',
          address: '',
          experience: '',
        });
      })
      .catch((error) => {
        console.error('Error:', error);  // Log any errors that occur
        alert('Failed to submit application');
      });
  };  
  
  return (
    <>
    <Header/>
    <div className="hole-container">
      <div className="app-container">
        <div className="content-container">
          <div className="job-list">
            <div className="alert-bar">
              <div className="alert-content">
                <span className="alert-title">Jobs in Worldwide</span>
                <span className="alert-count">2 results</span>
              </div>
              <div className="alert-actions">
                <button className="alert-toggle" onClick={toggleAlert}>
                  <span className="toggle-text">
                    {alertOn ? "Alert On" : "Set alert"}
                  </span>
                  <span className={`toggle-icon ${alertOn ? "on" : "off"}`}></span>
                </button>
              </div>
            </div>

            {jobs.map((job) => (
              <div key={job.id} className="job-item">
                <div className="job-info" onClick={() => handleJobClick(job)}>
                  <h3>{job.title}</h3>
                  <p>{job.company}</p>
                  <p>{job.location}</p>
                  <p>{job.type}</p>
                </div>
                <button
                  className="x-btn"
                  onClick={() => handleJobClose(job.id)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {selectedJob ? (
            <div className="job-details">
              <h2>{selectedJob.title}</h2>
              <p><strong>Company:</strong> {selectedJob.company}</p>
              <p><strong>Location:</strong> {selectedJob.location}</p>
              <p><strong>Type:</strong> {selectedJob.type}</p>
              <p><strong>Benefits:</strong> {selectedJob.benefits || "N/A"}</p>
              <div className="description">
                <h3>About the Job</h3>
                <p>{selectedJob.description}</p>
              </div>
              <div className="actions">
                <button className="button" onClick={() => setShowApplicationForm(true)}>
                   Apply Now
                </button>
                <button className="button" onClick={() => handleConnect(selectedJob.id)}>
                     Save
                </button>
               </div>
              </div>
          ) : (
            <p>Select a job to view details</p>
          )}
        </div>

        {showApplicationForm && (
  <div className="modal">
    <div className="modal-content">
      <button
        className="close"
        onClick={() => setShowApplicationForm(false)}
      >
        &times;
      </button>
      <h2>Apply for Job</h2>
      <form>
        <label>Name:</label>
        <input
          type="text"
          name="name"
          value={applicationForm.name}
          onChange={handleApplicationInputChange}
        />

        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={applicationForm.email}
          onChange={handleApplicationInputChange}
        />

        <label>Address:</label>
        <textarea
          name="address"
          value={applicationForm.address}
          onChange={handleApplicationInputChange}
        ></textarea>

        <label>Experience:</label>
        <input
          type="text"
          name="experience"
          value={applicationForm.experience}
          onChange={handleApplicationInputChange}
        />

        <button
          type="button"
          onClick={submitApplication}
        >
          Submit Application
        </button>
      </form>
    </div>
  </div>
 )}
   </div>
  </div>
  </>
  );
}

export default Jobs;
